import request from '@/service/index'
import qs from 'qs'

export const getTaskList = () => {
  return request({
    url: '/taskOrder/getAllTaskStatus',
    method: 'GET'
  })
}

export const getPriceList = () => {
  return request({
    url: '/taskOrder/getAllPrices',
    method: 'GET'
  })
}

export const submitFeedback = (data: any) => {
  return request({
    url: '/cms/saveFeedback',
    method: 'POST',
    data: qs.stringify(data)
  })
}
